import React, { useState, useMemo } from 'react';

import { useStatusTemplates } from 'Templates';

import {
  Stack,
  UploadFile,
  Button,
  makeStyles,
  Alert,
  Paper,
  Badge,
} from '@gogame/components';
import { useChildComponent } from '@gogame/hooks-ts';

import { TEMPLATE_PLAYERS_INFORMATION } from 'scenes/PlayersActivities/PlayersInformation/constants';
import { useBulkUpload } from 'scenes/PlayersActivities/PlayersInformation/data/mutations';

import { Container, Content, Footer } from '../Container';
import DownloadTemplate from '../DownloadTemplate';
import EventNames from '../EventNames';

const useStyles = makeStyles(() => ({
  uploadPaper: {
    padding: '16px',
    borderStyle: 'dotted',
  },
  uploadBlock: {
    paddingTop: '16px',
  },
  badge: {
    transform: 'translate(20%, -50%)',
  },
}));

const BulkRequest = () => {
  const classes = useStyles();
  const [childComponent, openChildComponent] = useChildComponent();
  const [file, setFile] = useState();
  const [errorMessage, setErrorMessage] = useState(null);

  const [bulkUpload] = useBulkUpload();
  const handleViewEventNames = () => {
    openChildComponent(EventNames);
  };

  const handleExport = () => {
    openChildComponent(DownloadTemplate);
  };

  const handleUpload = (_, [file]) => {
    // bulkUpload(file);
    setErrorMessage(null);
    setFile(file);
  };

  const handleApply = () => {
    if (file) {
      bulkUpload(file);
      setFile(null);
      setErrorMessage(null);
    } else {
      setErrorMessage('File is required');
    }
  };

  const handleClear = () => {
    setFile(null);
    setErrorMessage(null);
  };

  const fileName = useMemo(() => {
    let values = file?.values() || [];
    return file && [...values]?.[0]?.name;
  }, [file]);

  const templateUpdated = useStatusTemplates({
    name: TEMPLATE_PLAYERS_INFORMATION,
  });

  return (
    <Container>
      {childComponent}
      <Content>
        <Stack spacing={2} className={classes.uploadBlock}>
          <Alert>The results will be sent to your email</Alert>
          <Paper variant={'outlined'} className={classes.uploadPaper}>
            <UploadFile
              label={'Select file *'}
              accept={'.csv'}
              tooltip={'Only .csv files are acceptable'}
              onUpload={handleUpload}
              helper={fileName}
              error={errorMessage}
            />
          </Paper>
          <Stack direction={'column'} alignItems={'flex-end'} spacing={2}>
            <Badge
              invisible={!templateUpdated}
              badgeContent={'Updated'}
              color={'error'}
              componentsProps={{
                badge: {
                  className: classes.badge,
                },
              }}
            >
              <Button onClick={handleExport} variant={'outlined'}>
                Download template
              </Button>
            </Badge>
            <Button onClick={handleViewEventNames} variant={'outlined'}>
              View Events
            </Button>
          </Stack>
        </Stack>
      </Content>
      <Footer justifyContent={'space-between'}>
        <Button onClick={handleClear} role={'button'}>
          Clear
        </Button>
        <Button variant={'contained'} onClick={handleApply}>
          Apply
        </Button>
      </Footer>
    </Container>
  );
};

export default BulkRequest;
